import { Component, HostBinding, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserProfileDto } from 'src/app/api/identity/models';
import { UsersService } from 'src/app/api/identity/services';
import {
  ChildRouteInterface,
  RouteInterface,
} from 'src/app/shared/models/user.model';
import {
  BrandProfile,
  BrandingService,
} from 'src/app/shared/branding/branding.service';
import { RedirectService } from 'src/app/shared/services/redirect-service';

const BASE_CLASSES = 'main-sidebar elevation-4';

@Component({
  selector: 'app-sub-sidebar',
  templateUrl: './sub-sidebar.component.html',
  styleUrls: ['./sub-sidebar.component.scss'],
})
export class SubSidebarComponent implements OnInit {
  @HostBinding('class') classes: string = BASE_CLASSES;

  public menu = JSON.parse(JSON.stringify(MENU));
  public loggedInUserName = '';
  public userPermissions: string[] = [];
  readonly brand: BrandProfile;
  loggedInUser: UserProfileDto = {};

  constructor(
    private userService: UsersService,
    private toastr: ToastrService,
    private redirectService: RedirectService,
    branding: BrandingService
  ) {
    this.brand = branding.brand;
  }

  ngOnInit() {
    this.fetchLoggedInUser();
  }

  checkPermissions(item: RouteInterface): boolean {
    if (!item) {
      return false;
    }

    if (item.permissions) {
      const hasPermission = item.permissions.every((permission: string) =>
        this.redirectService.hasPermission(permission)
      );

      if (!hasPermission) {
        return false;
      }
    }

    if (item.children && item.children.length > 0) {
      const visibleChildren = item.children.filter(
        (child: ChildRouteInterface) => {
          return this.checkPermissions(child);
        }
      );

      item.children = visibleChildren;

      return visibleChildren.length > 0;
    }

    return true;
  }

  fetchLoggedInUser() {
    this.userService.getLoggedInUserDetails().subscribe({
      next: user => {
        if (user?.data) {
          this.loggedInUserName = user?.data[0]?.name || '';
          this.loggedInUser = user?.data[0] || {};

          this.redirectService.setPermissions(
            this.loggedInUser.Privileges || []
          );
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }
}

export const MENU = [
  {
    name: 'Sales',
    iconClasses: 'fas fa-shopping-cart',
    permissions: ['SALES_VIEW_FE'],
    path: ['/'],
    children: [
      {
        name: 'Quotation',
        iconClasses: 'fas fa-envelope',
        path: ['/sales/quotations'],
      },

      {
        name: 'Work order',
        iconClasses: ' fas fa fa-tasks',
        path: ['sales/work-order'],
      },
      {
        name: 'Invoice',
        iconClasses: ' fas fa-file-invoice',
        path: ['sales/invoice'],
      },
      {
        name: 'CHMS Credit note',
        iconClasses: 'fas fa-receipt',
        path: ['sales/chms-credit-note'],
      },
    ],
  },
  {
    name: 'ACMS Sales',
    iconClasses: 'fas fa-tags',
    permissions: ['ACMS_SALES_VIEW_FE'],
    path: ['/'],
    children: [
      {
        name: 'Quotation',
        iconClasses: 'fas fa-envelope',
        path: ['/acms-sales/quotations'],
      },
      {
        name: 'Work order',
        iconClasses: ' fas fa fa-tasks',
        path: ['/acms-sales/acms-sales-work-order'],
      },
      {
        name: 'Invoice',
        iconClasses: 'fas fa-file-invoice',
        path: ['/acms-sales/acms-sales-invoice'],
      },
    ],
  },
  {
    name: 'Sales Order',
    iconClasses: 'fa fa-shopping-basket',
    permissions: ['SALES_VIEW_FE'],
    path: ['/sales-order'],
    children: [
      {
        name: 'List',
        iconClasses: 'fas fa-envelope',
        path: ['/sales-order/list'],
      },
      {
        name: 'Invoice',
        iconClasses: ' fas fa-file-invoice',
        path: ['sales-order/invoice'],
      },
    ],
  },

  {
    name: 'MCC',
    iconClasses: 'fas fa-wrench',
    path: ['/mcc'],
    permissions: ['MCC_VIEW_FE'],
    children: [
      {
        name: 'Invoice',
        iconClasses: 'fas fa-file-invoice',
        path: ['mcc/invoice'],
      },
    ],
  },
  {
    name: 'Medevac',
    iconClasses: 'fas fa-moon',
    path: ['/medevac'],
    permissions: ['MEDEVAC_VIEW_FE'],
    children: [
      {
        name: 'Flight',
        iconClasses: 'fas fa-plane',
        path: ['/medevac/flight'],
        permissions: ['FLIGHT_VIEW_FE'],
        children: [
          {
            name: 'Quotation',
            iconClasses: 'fas fa-envelope',
            path: ['/medevac/flight/quotation'],
          },
          {
            name: 'Invoice',
            iconClasses: ' fas fa-file-invoice',
            path: ['/medevac/flight/invoice'],
          },
        ],
      },
      {
        name: 'First/Aid',
        iconClasses: 'fas fa-first-aid',
        path: ['/medevac/first-aid'],
        permissions: ['FIRSTAID_VIEW_FE'],
        children: [
          {
            name: 'Quotation',
            iconClasses: 'fas fa-envelope',
            path: ['/medevac/first-aid/first-aid-quotation'],
          },
          {
            name: 'Invoice',
            iconClasses: 'fas fa-file-invoice',
            path: ['/medevac/first-aid/invoice'],
          },
        ],
      },
      {
        name: 'Escort',
        iconClasses: 'fas fa-flag',
        path: ['/medevac/escort'],
        permissions: ['ESCORT_VIEW_FE'],
        children: [
          {
            name: 'Quotation',
            iconClasses: 'fas fa-envelope',
            path: ['/medevac/escort/escort-quotation'],
          },
          {
            name: 'Invoice',
            iconClasses: ' fas fa-file-invoice',
            path: ['/medevac/escort/escort-invoice'],
          },
        ],
      },
    ],
  },

  {
    name: 'Finance',
    iconClasses: 'fas fa-money-bill',
    path: ['finance'],
    permissions: ['FINANCE_VIEW_FE'],
    children: [
      {
        name: 'Quotation',
        iconClasses: 'fas fa-envelope',
        path: ['/finance/finance-quotation'],
      },
      {
        name: 'Invoice',
        iconClasses: 'fas fa-envelope',
        path: ['/finance/finance-invoice'],
      },
    ],
  },

  {
    name: 'Contracts',
    iconClasses: 'fas fa-file-contract',
    path: ['/contracts'],
    permissions: ['CHARTER_CONTRACTS_VIEW_FE'],
  },

  {
    name: 'Training',
    iconClasses: 'fas fa-graduation-cap',
    path: ['training'],
    permissions: ['TRAINING_VIEW_FE'],
    children: [
      {
        name: 'Invoice',
        iconClasses: 'fas fa-file-invoice',
        path: ['/training/invoice'],
        visible: true,
      },
    ],
  },
  {
    name: 'ACMS',
    iconClasses: 'fas fa-screwdriver',
    path: ['acms'],
    permissions: ['ACMS_VIEW_FE'],
    children: [
      {
        name: 'Service Item',
        iconClasses: 'fas fa-tags',
        path: ['acms/service'],
        visible: true,
      },
      {
        name: 'Aircraft',
        iconClasses: ' fas fa-plane',
        path: ['acms/aircraft'],
      },

      {
        name: 'Service Order',
        iconClasses: 'fas fa-bars',
        path: ['acms/service-order'],
      },
      {
        name: 'Invoice',
        iconClasses: ' fas fa-file-invoice',
        path: ['acms/invoice'],
      },
      {
        name: 'Add Cost Center',
        iconClasses: 'fas fa-coins',
        path: ['acms/add-cost-center'],
      },
    ],
  },
  {
    name: 'GIS',
    iconClasses: 'fas fa-plane-arrival',
    path: ['gis'],
    permissions: ['GIS_VIEW_FE'],

    children: [
      {
        name: 'Work Order',

        iconClasses: 'fas fa-tasks',
        path: ['gis/upload'],
      },
      {
        name: 'Generate invoice',
        iconClasses: 'fas fa-file-upload',
        path: ['gis/generate-invoice'],
      },
      {
        name: 'Invoice',
        iconClasses: 'fas fa-file-invoice',
        path: ['gis/invoice'],
      },
      {
        name: 'Upload logs',
        iconClasses: 'fas fa-list-alt',
        path: ['gis/upload-logs'],
      },
    ],
  },
  {
    name: 'GH',
    iconClasses: 'fas fa-warehouse',
    path: ['gh'],
    permissions: ['GIS_VIEW_FE'],
    children: [
      {
        name: 'Work order',
        iconClasses: 'fas fa-tasks',
        path: ['gh/work-order'],
      },
      {
        name: 'Invoice',
        iconClasses: 'fas fa-file-invoice',
        path: ['gh/invoice'],
      },
    ],
  },
  {
    name: 'Airport',
    iconClasses: 'fas  fa-plane',
    path: ['airport'],
    permissions: ['AIRPORT_MANAGEMENT_SERVICE_VIEW_FE'],
    children: [
      {
        name: 'Quotation',
        iconClasses: 'fas fa-envelope',
        path: ['/airport/airport-quotation'],
      },
      {
        name: 'Invoice',
        iconClasses: 'fas fa-file-invoice',
        path: ['/airport/airport-invoice'],
      },
    ],
  },
  {
    name: 'Invoice',
    iconClasses: 'fas fa-file-invoice',
    permissions: ['VIEW_INVOICE_TAB'],
    path: ['/invoices'],
  },
  {
    name: 'Zatca information',
    iconClasses: 'fas fa-info-circle',
    permissions: ['ZATCA_INVOICE_VIEW_FE'],
    path: ['/zatca-info-list'],
  },

  {
    name: 'Reports',
    iconClasses: 'fa-solid fa-file-excel',
    permissions: ['REPORTS_VIEW_FE'],
    path: ['/report'],

    children: [
      {
        name: 'Vat Report',
        permissions: ['VIEW_VAT_REPORT_FE'],
        iconClasses: 'fas fa-file-alt',
        path: ['/report/vat'],
      },

      {
        name: 'Trip Report',
        iconClasses: 'fas fa-plane',
        permissions: ['VIEW_TRIP_REPORT_FE'],
        path: ['/report/trip'],
      },
      {
        name: 'GIS Report',
        iconClasses: 'fas fa-plane-arrival',
        permissions: ['GIS_REPORT_VIEW_FE'],
        path: ['/report/gis-report'],
      },
      {
        name: 'Leg wise Report',
        iconClasses: 'fas fa-book',
        permissions: ['LEG_WISE_REPORT_VIEW_FE'],
        path: ['/report/leg-wise'],
      },
      {
        name: 'Oracle Web ADI',
        iconClasses: 'fa fa-database',
        permissions: ['ORACLE_REPORT_VIEW_FE'],
        path: ['/report/oracle-web-adi-report'],
      },
      {
        name: 'Bulk Invoice',
        iconClasses: 'fa-regular fa-file-zipper',
        permissions: ['VIEW_BULK_INVOICE_TAB'],
        path: ['/report/invoice-bulk-download'],
      },
      {
        name: 'ACMS Report',
        iconClasses: 'fas fa-chart-line',
        permissions: ['ACMS_REPORT_VIEW_FE'],
        path: ['/report/acms-report'],
      },
      {
        name: 'Contract Report',
        iconClasses: 'fas fa-file-contract',
        permissions: ['LIST_CHARTER_CONTRACTS'],
        path: ['/report/contract-report'],
      },
    ],
  },
  {
    name: 'Payment',
    iconClasses: 'fas  fa-money-check',
    path: ['/payments'],
    permissions: ['ADVANCE_PAYMENT_VIEW_FE'],
  },

  {
    name: 'Settings',
    iconClasses: 'fas fa-cogs',
    path: ['/'],
    children: [
      {
        name: 'Client',
        iconClasses: 'fas fas fa-users',
        path: ['settings/clients'],
        permissions: ['CLIENT_VIEW_FE'],
      },
      {
        name: 'Bank',
        iconClasses: 'fas fa-university',
        path: ['settings/banks'],
        permissions: ['BANK_VIEW_FE'],
      },
      {
        name: 'Aircraft',
        iconClasses: 'fas fa fa-plane',
        path: ['settings/aircraft'],
        permissions: ['AIRCRAFT_VIEW_FE'],
      },
      {
        name: 'Unit',
        iconClasses: 'fas fa fa-cube',
        path: ['settings/unit'],
        permissions: ['UNIT_VIEW_FE'],
      },
      {
        name: 'Currency',
        iconClasses: 'fas fa fa-dollar',
        path: ['settings/currency'],
        permissions: ['CURRENCY_TAB_FE'],
      },
      {
        name: 'Division',
        iconClasses: 'fas fa-sitemap',
        path: ['settings/division'],
        permissions: ['DIVISION_VIEW_FE'],
      },
      {
        name: 'Cost center',
        iconClasses: 'fas fa-coins',
        path: ['settings/cost-center'],
        permissions: ['COST_CENTER_VIEW_FE'],
      },
      {
        name: 'Account',
        iconClasses: 'fas fa-users',
        path: ['settings/account'],
        permissions: ['ACCOUNT_VIEW_FE'],
      },
      {
        name: 'EBS CM Reasons',
        iconClasses: 'fas fa-database',
        path: ['settings/ebs'],
        permissions: ['LIST_CM_REASON'],
      },
      {
        name: 'Send to EBS',
        iconClasses: 'fas fa-share-from-square',
        path: ['settings/send-to-ebs'],
        permissions: ['BUSSINESS_TYPE_EBS_CONFIG_LIST'],
      },
      {
        name: 'Meals Type',
        iconClasses: 'fas fa-utensils',
        path: ['settings/meals-type'],
        permissions: ['LIST_MEAL_CATEGORY'],
      },
      {
        name: 'Internet Type',
        iconClasses: 'fas fa-wifi',
        path: ['settings/internet-type'],
        permissions: ['LIST_INTERNET_PACKAGE'],
      },
      {
        name: 'Layover Type',
        iconClasses: 'fas fa-clock',
        path: ['settings/layover-type'],
        permissions: ['LIST_LAYOVER_CATEGORY'],
      },
      {
        name: 'Waiting Type',
        iconClasses: 'fas fa-hourglass-half',
        path: ['settings/waiting-type'],
        permissions: ['LIST_WAITING_CATEGORY'],
      },
    ],
  },
];
